import { EventEmitter, Injectable } from "@angular/core";
import { CreateOperationInterface, OperationInterfaceOFC } from "src/app/interface/operation.interface";

@Injectable()
export class OperationManagementService {
  constructor() {}

  newOperationEvent = new EventEmitter<OperationInterfaceOFC>();
  updateOperationEvent = new EventEmitter<CreateOperationInterface>();

  newAssociationOperationFeatureEvent = new EventEmitter<void>();

  navigateToOperationManagement = new EventEmitter<void>();
}